import { NumberSymbol, formatNumber, getLocaleNumberSymbol, registerLocaleData } from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeCH from '@angular/common/locales/de-CH';
import localeFR from '@angular/common/locales/fr-CH';
import localeIT from '@angular/common/locales/it-CH';
import { Pipe, PipeTransform } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import Debug from 'debug';

registerLocaleData(localeCH);
registerLocaleData(localeDE);
registerLocaleData(localeFR);
registerLocaleData(localeIT);

const debug = Debug('aumico:aumico-lib-core-fe:AumFinancialNumberPipe');

@Pipe({
    name: 'finNumber',
    pure: false,
})
export class AumFinancialNumberPipe implements PipeTransform {
    constructor(private i18NextService: I18NextService) {}

    format(value: number, format: string = '1.2-2', nonBreakingHyphen: boolean = false, language?: string): string {
        if (language == null) {
            language = this.i18NextService.language;
        }

        try {
            let formattedValue = formatNumber(value, language, format);

            if (nonBreakingHyphen) {
                // Replace normal minus sign with a non-breaking hyphen
                formattedValue = formattedValue.replace(/-/g, '\u2011');
            }

            return formattedValue;
        } catch (error) {
            debug('try to convert a value, which is no number...', value);
            if (value == null) return 'null';
            return value.toString();
        }
    }

    transform(value: number, format?: string, nonBreakingHyphen: boolean = false, language?: string): string {
        if (value == null) {
            return '-';
        }
        const formatLanguage = language == null ? this.i18NextService.language : language;

        return this.format(value, format, nonBreakingHyphen, formatLanguage);
    }

    parseFormattedNumber(formattedNumber: string, nonBreakingHyphen: boolean = false): number {
        // Get locale-specific symbols.
        const decimalSeparator = getLocaleNumberSymbol(this.i18NextService.language, NumberSymbol.Decimal);
        const groupSeparator = getLocaleNumberSymbol(this.i18NextService.language, NumberSymbol.Group);

        let normalizedNumber = formattedNumber;
        if (nonBreakingHyphen) {
            // Replace non-breaking hyphen with normal minus sign
            normalizedNumber = formattedNumber.replace(/\u2011/g, '-');
        }

        // Remove group (thousands) separator and replace decimal separator with dot.
        const cleanedNumber = normalizedNumber
            .replace(new RegExp('\\' + groupSeparator, 'g'), '') // Remove thousands separator
            .replace(new RegExp('\\' + decimalSeparator), '.'); // Replace decimal separator with dot

        // Convert to number.
        return parseFloat(cleanedNumber);
    }
}
